export default __webpack_public_path__ + "static/media/joomla.c0e4a505.svg";